"use client";

import Image from "next/image";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

function formatIDR(amount) {
    return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
    }).format(amount);
}

export default function CartItem({ item }) {
    const { removeItem, updateQty } = useCart();
    const { showToast } = useAuth();
    const showQty = item.type !== "invitation";

    return (
        <li className="flex gap-3 rounded-xl border border-zinc-100 bg-white p-3 shadow-sm">
            <div className="relative h-20 w-20 shrink-0 overflow-hidden rounded-lg bg-primary-light">
                {(item.image || item.image_url) && (
                    <Image
                        src={item.image || item.image_url}
                        alt={item.name}
                        fill
                        className="object-cover"
                        sizes="80px"
                    />
                )}
            </div>
            <div className="flex flex-1 flex-col gap-1">
                <p className="text-sm font-semibold text-zinc-900 leading-tight">
                    {item.name}
                </p>
                <p className="text-xs text-zinc-500 line-clamp-2">
                    {item.description}
                </p>
                <p className="text-sm font-semibold text-primary-dark">
                    {formatIDR(item.price)}
                </p>
                <div className="mt-auto flex items-center justify-between">
                    {showQty ? (
                        <div className="flex items-center gap-1 rounded-full border border-zinc-200 px-1">
                            <button
                                onClick={() => updateQty(item.id, item.qty - 1)}
                                className="flex h-6 w-6 cursor-pointer items-center justify-center rounded-full text-zinc-600 transition hover:bg-primary-light hover:text-primary-dark"
                                aria-label="Kurangi"
                            >
                                −
                            </button>
                            <span className="min-w-6 text-center text-sm font-medium">
                                {item.qty}
                            </span>
                            <button
                                onClick={() => updateQty(item.id, item.qty + 1)}
                                className="flex h-6 w-6 cursor-pointer items-center justify-center rounded-full text-zinc-600 transition hover:bg-primary-light hover:text-primary-dark"
                                aria-label="Tambah"
                            >
                                +
                            </button>
                        </div>
                    ) : (
                        <div />
                    )}
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => {
                                removeItem(item.id);
                                showToast(`"${item.name}" dihapus dari keranjang.`);
                            }}
                            className="cursor-pointer text-xs text-zinc-400 underline transition hover:text-red-500"
                        >
                            Hapus
                        </button>
                    </div>
                </div>
            </div>
        </li>
    );
}
